import React, { createContext, useCallback, useReducer } from 'react';

export default (reducer, actions, initialState) => {
  const Context = createContext({});

  const Provider = ({ children }) => {
    const init = () => {
      return Object.keys(initialState).reduce((obj, key) => {
        let value;
        try {
          // Get from local storage by key
          const item = window.localStorage.getItem(key);
          // Parse stored json or if none return initialValue
          value = item ? JSON.parse(item) : initialState[key];
        } catch (error) {
          // If error also return initialValue
          console.log(error);
          value = initialState[key];
        }
        return { ...obj, [key]: value };
      }, {});
    };

    const reducerLocalStorage = useCallback((state, action) => {
      const newState = reducer(state, action);
      const { type, ...rest } = action;
      const setItem = ({ key, value = initialState[key] }) => {
        try {
          // Set from local storage by key
          window.localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
          console.log(error);
        }
      };
      if (type === 'clearBookerContext') {
        Object.keys(initialState).forEach(key => {
          setItem({ key });
        });
      } else {
        const [key = '', value] = Object.entries(rest)[0];
        setItem({ key, value });
      }
      return newState;
    }, []);

    const [state, dispatch] = useReducer(reducerLocalStorage, initialState, init);

    const boundActions = {};
    for (let key in actions) {
      if (actions.hasOwnProperty(key)) boundActions[key] = actions[key](dispatch);
    }

    return <Context.Provider value={{ state, ...boundActions }}>{children}</Context.Provider>;
  };

  return { Context, Provider };
};
